"use client";

import { useReducedMotion } from "framer-motion";
import { useScrollContext } from "@/components/motion/SmoothScrollProvider";
import { useTheme } from "@/components/theme/ThemeProvider";
import { cn } from "@/lib/utils";

export function ScrollProgress() {
  const { progress } = useScrollContext();
  const reduced = useReducedMotion();
  const { theme } = useTheme();
  const percent = Math.round(progress * 100);

  return (
    <div
      className="pointer-events-none fixed top-0 left-0 right-0 z-[55] h-[3px] bg-transparent"
      aria-hidden="true"
    >
      <div
        className={cn(
          "h-full origin-left",
          theme === "light" ? "bg-[var(--programs-green)]" : "bg-primary",
          reduced ? "" : "transition-[width] duration-100 linear"
        )}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
